import { Checkbox } from "@/components/ui/checkbox";
import { gbp, fmtDate } from "@/lib/format";
import { StatusBadge, SourceTag } from "@/components/StatusBadge";

export const OrdersTable = ({ items, onOpen, selectable, selected = [], setSelected }) => {
  const allOn = items.length > 0 && items.every((o) => selected.includes(o.id));
  const toggle = (id) => setSelected(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <div className="overflow-x-auto rounded-lg border bg-white">
      <table className="w-full min-w-[860px] text-sm" data-testid="orders-table">
        <thead className="border-b bg-slate-50/80 text-left"><tr className="label-xs">
          {selectable && <th className="w-10 px-4 py-3"><Checkbox checked={allOn} onCheckedChange={() => setSelected(allOn ? [] : items.map((o) => o.id))} data-testid="select-all-orders" /></th>}
          <th className="px-4 py-3">Order</th><th className="px-4 py-3">Date</th><th className="px-4 py-3">Store / Concession</th>
          <th className="px-4 py-3">Region</th><th className="px-4 py-3">Source</th><th className="px-4 py-3 text-right">Lines</th>
          <th className="px-4 py-3 text-right">Total</th><th className="px-4 py-3">Status</th>
        </tr></thead>
        <tbody>
          {items.length === 0 && <tr><td colSpan={9} className="py-14 text-center text-slate-500" data-testid="orders-empty">No orders match these filters</td></tr>}
          {items.map((o) => (
            <tr key={o.id} onClick={() => onOpen(o.id)} data-testid={`order-row-${o.id}`}
              className="cursor-pointer border-b transition-colors last:border-0 hover:bg-[#FF0000]/[0.03]">
              {selectable && <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}><Checkbox checked={selected.includes(o.id)} onCheckedChange={() => toggle(o.id)} data-testid={`select-order-${o.id}`} /></td>}
              <td className="px-4 py-3"><div className="font-mono text-xs font-semibold">{o.order_number}</div><div className="text-[11px] text-slate-400">PO {o.po_ref}</div></td>
              <td className="whitespace-nowrap px-4 py-3">{fmtDate(o.date_ordered)}</td>
              <td className="px-4 py-3"><div className="font-medium">{o.concession_name || o.store_name}</div>{o.concession_name && <div className="text-xs text-slate-500">{o.store_name}</div>}</td>
              <td className="px-4 py-3 text-slate-600">{o.region}</td>
              <td className="px-4 py-3"><SourceTag source={o.source} /></td>
              <td className="px-4 py-3 text-right tabular-nums">{o.line_count}</td>
              <td className="px-4 py-3 text-right font-semibold tabular-nums">{gbp(o.total)}</td>
              <td className="px-4 py-3"><StatusBadge status={o.status} /></td>
            </tr>))}
        </tbody>
      </table>
    </div>
  );
};
